import { render, staticRenderFns } from "./WorkshopSummary.vue?vue&type=template&id=c959e082&"
import script from "./WorkshopSummary.vue?vue&type=script&lang=ts&"
export * from "./WorkshopSummary.vue?vue&type=script&lang=ts&"
import style0 from "./WorkshopSummary.vue?vue&type=style&index=0&id=c959e082&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports